import React from 'react';
import { createGetOptionsFunc } from './extreact-style-params';
const hashToInt = function (str) {
  if (str === void 0) {
    str = '';
  }
  let int = 0;
  for (let i = 0; i < str.length; i++) {
    int += str.charCodeAt(i);
  }
  return int;
};
function getServerParams(props) {
  const {
    items,
    rawOptions = props.options
  } = props;
  const itemsStr = items.slice(0, 20).map(item => `${hashToInt(item.mediaUrl)}_${item.width || item.metaData.width}_${item.height || item.metaData.height}`).join('|');
  const getOptions = createGetOptionsFunc(rawOptions);
  const hrefStr = `/_serverless/pro-gallery-native-layout-fixer/layoutCssNative?id=${props.id}&items=${itemsStr}&container=`;
  return {
    hrefStr,
    getOptions
  };
}
function createSsrJs(props) {
  const {
    hrefStr,
    getOptions
  } = getServerParams(props);
  const embed = content => `
  var ele = document.getElementById('${'pro-gallery-' + props.id}');
  ${content}
  var isVertical = options.includes('layoutParams_structure_scrollDirection:"VERTICAL"');
  var layoutFixerUrl =  '${hrefStr}' + pgMeasures.top + '_' + pgMeasures.width + '_' + pgMeasures.height + '_' + window.innerHeight + '&options=' + options;
  document.getElementById('${'layout-fixer-style-' + props.id}').setAttribute('href', encodeURI(layoutFixerUrl));
});

  `;
  return embed(`
      var nativeComp = document.getElementById("${props.id}"), nativeRect = nativeComp.getBoundingClientRect();
      var pgMeasures = {top: nativeRect.top, width: nativeRect.width, height: Number(getComputedStyle(nativeComp).getPropertyValue("height").replace("px", ""))};
      var options = (${getOptions})(ele);
    `);
}
export const LayoutFixer = props => {
  try {
    var _window$document$getE;
    const existingLinkUrl = typeof window !== 'undefined' ? (((_window$document$getE = window.document.getElementById('layout-fixer-style-' + props.id)) == null ? void 0 : _window$document$getE.href) || '').replace(/^.*\/\/[^/]+/, '') : '';
    return /*#__PURE__*/React.createElement("div", {
      id: 'layout-fixer-' + props.id,
      key: 'layout-fixer-' + props.id,
      style: {
        display: 'none'
      }
    }, /*#__PURE__*/React.createElement("link", {
      rel: "stylesheet",
      id: 'layout-fixer-style-' + props.id,
      href: existingLinkUrl
    }), /*#__PURE__*/React.createElement("script", {
      dangerouslySetInnerHTML: {
        __html: `try {
            window.requestAnimationFrame(function() {
              ${createSsrJs(props)}
        } catch (e) {
          console.warn('Cannot set layoutFixer css', e);
        }`
      }
    }));
  } catch (e) {
    return /*#__PURE__*/React.createElement("div", {
      id: "layoutFixerErrors",
      style: {
        display: 'none'
      }
    }, e.toString());
  }
};
//# sourceMappingURL=layoutFixer.js.map